
function getPlatform() {
  var isWin = (navigator.platform == "Win32") || (navigator.platform == "Windows");
  if (isWin) return "Win";
  var isMac = (navigator.platform == "Mac68K") || (navigator.platform == "MacPPC") || (navigator.platform == "Macintosh") || (navigator.platform == "MacIntel");
  if (isMac) return "Mac";
}
function getElTable(ele){
  
}
function hasOverLayer(element) {
  let document = element.ownerDocument;
  let {x, y, width, height} = element.getBoundingClientRect();
  x |= 0;
  y |= 0;
  width |= 0;
  height |= 0;
  let elements = [
    document.elementFromPoint(x, y),
    document.elementFromPoint(x + width, y),
    document.elementFromPoint(x, y + height),
    document.elementFromPoint(x + width, y + height)
  ];
  return elements.filter((el)=> el !== null).some((el)=> el !== element);
}

const getIndex = (list, event) => {
    let _index = -1;
    for (let i = 0; i < list.length; i++) {
      if (list[i] === event) {
        _index = i;
        break;
      }
    }
    return _index;
}
const getLastIndex = (list) => {
    const _s = [];
    for (let i = 0; i < list.length; i++) {
      if (list[i].disabled) {
        _s.push(i);
      }
    }
    console.log(_s);
    return _s[_s.length - 2];
}
const hiddenPopper = (pops)=>{
      for (let i = 0; i < pops.length; i++) {
        pops[i].style.display="none";
    }
}
/**
 * 判断元素是否为element下拉选择
 * @param {*} ele 
 * @returns 
 */
const isEleSelect = (ele)=>{
  const _parent = ele.parentNode.parentNode;//获取下一个需要获取焦点元素的爷爷节点 判断是否为element的下拉框
  return _parent.className&&typeof(_parent.className)==='string'&&_parent.className.indexOf('el-select')>-1;
}
const keyboardControl = {
    inserted:function(el, binding, vNode){
        //console.log("键盘控制：",el,binding,vNode)
        const _ele_box=el||document.body;
        //const _inputs=_ele_box.querySelectorAll('.el-input__inner .el-textarea__inner');
        const keyEvent = (event)=>{
            if(event.keyCode!==13){return;}
            const inputs = _ele_box.querySelectorAll('.el-input__inner,.el-textarea__inner');
            NodeList.prototype.some = Array.prototype.some;
            NodeList.prototype.filter = Array.prototype.filter;
            const ips = inputs.filter((item)=> {//过滤input元素
              const _not = _ele_box.querySelectorAll(".el-table td[class~=is-hidden] .el-input__inner,.el-table td[class~=is-hidden] .el-textarea__inner")
              const _isCover = _not.some((s)=>s===item)//判断是否为element表格固定列隐藏元素
              return !_isCover&&item.offsetParent !== null&&(!item.readOnly||isEleSelect(item))&&!item.disabled
            });
            const _pops = document.body.querySelectorAll('.el-popper');
            event.preventDefault();
            const focus = document.activeElement;
            const i = _ele_box.contains(focus) ? getIndex(ips, focus) : getLastIndex(ips);
            //console.log(el,ips,getLastIndex(ips) + 1, ips[i + 1]);
            if (i < ips.length - 1) {
                var nextEle = ips[i + 1];
                const _isElSelect = isEleSelect(nextEle);//获取下一个需要获取焦点元素的爷爷节点 判断是否为element的下拉框
                const _isCurrentElSel = isEleSelect(ips[i]);//判断当前是否为element的下拉框
                // const _isElSelectPre = isEleSelect(ips[i]);
                hiddenPopper(_pops)
                // ips[i].click();
                if(_isCurrentElSel){
                  const currentEle = ips[i];
                  currentEle.click();
                }
                if(_isElSelect){
                  nextEle.click()&&nextEle.focus();
                }else{
                  nextEle.focus()&&nextEle.click();
                }
                // if(_isElSelectPre){
                //   ips[i].click()
                // }
            }
            event.stopPropagation();
        }
        _ele_box.addEventListener('keydown', keyEvent)
    },
    unbind:function(el, binding, vNode){
      const { key } = binding.value;
    }
}
const keyDownEvent = {
  inserted:function(el, binding, vNode){
    let {  } = binding.value;

    if((getPlatform === 'Win' && e.ctrlKey) || (getPlatform === 'Mac' && e.metaKey)){
      
    }
  }
}
export { keyboardControl };


// WEBPACK FOOTER //
// ./src/directives/src/keyboard-control/index.js